import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateProjectDraftMutation as CreateProjectDraftMutationType,
  CreateProjectDraftMutationVariables,
} from "./__generated__/CreateProjectDraftMutation";

const CreateProjectDraftMutation = loader("./CreateProjectDraftMutation.gql");

type CreateProjectDraftMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateProjectDraftMutationType) => void;
}) => ReactElement;

export const CreateProjectDraftMutationProvider: CreateProjectDraftMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateProjectDraftMutationType, CreateProjectDraftMutationVariables>(
    CreateProjectDraftMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
